(function () {
  'use strict';
  // Genuine-only live Judge.me sync for upk-reviews on product pages (P6.2: the token is Theme settings
  // judgeme_public_token, printed on the root as data-jdgm-token by snippets/upk-reviews-store and sections/upk-reviews).
  // If Judge.me returns written reviews for THIS product, the section is
  // rebuilt with only those (no other products' reviews mixed in).
  // Otherwise the server-rendered block is left untouched.
  // Review text is escaped, never altered.

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }
  function stars(rating) {
    return '<span class="upk-rev-stars"><span class="upk-rev-stars-bg">\u2605\u2605\u2605\u2605\u2605</span>' +
      '<span class="upk-rev-stars-fg" style="width: ' + (rating * 20) + '%;">\u2605\u2605\u2605\u2605\u2605</span></span>';
  }
  // Customer-uploaded photo (first one) when the review has one; otherwise nothing.
  function photo(r, name) {
    var p = (r.pictures_urls && r.pictures_urls[0]) || (r.pictures && r.pictures[0]);
    if (!p) return '';
    var u = p.original || p.huge || (p.urls && (p.urls.original || p.urls.huge)) || '';
    if (typeof u !== 'string' || u.indexOf('https://') !== 0) return '';
    u = u.replace(/width=\d+/, 'width=400');
    return '<img class="upk-rev-photo" src="' + esc(u) + '" alt="Photo shared by ' + name + '" width="400" height="400" loading="lazy">';
  }
  function card(r) {
    var name = esc(r.reviewer_name || 'Customer');
    var verified = r.verified_buyer === true || r.verified === 'buyer';
    return '<div class="upk-rev-card">' + stars(r.rating || 5) +
      '<p class="upk-rev-card-text">&ldquo;' + esc(r.body || '') + '&rdquo;</p>' +
      photo(r, name) +
      '<div class="upk-rev-card-footer"><span class="upk-rev-avatar-fallback">' + name.charAt(0) + '</span>' +
      '<div><div class="upk-rev-card-name">' + name + '</div>' +
      (verified ? '<span class="upk-rev-card-verified">Verified buyer</span>' : '') +
      '</div></div></div>';
  }

  async function fetchAll(shop, token, productId) {
    var all = [];
    for (var page = 1; page <= 25; page++) {
      var url = 'https://api.judge.me/api/v1/widgets/product_review?shop_domain=' + encodeURIComponent(shop) +
        '&api_token=' + encodeURIComponent(token) + '&external_id=' + encodeURIComponent(productId) +
        '&per_page=100&page=' + page + '&json_request=true';
      var data;
      try {
        var res = await fetch(url);
        if (!res.ok) break;
        data = await res.json();
      } catch (e) { break; }
      var list = (data && data.reviews) || (data && data.response && data.response.reviews) || [];
      if (!list.length) break;
      all = all.concat(list);
      if (list.length < 100) break;
    }
    return all;
  }

  function render(root, reviews) {
    var rated = reviews.filter(function (r) { return r && r.rating; });
    if (!rated.length) return;
    var maxD = parseInt(root.getAttribute('data-max-display'), 10) || 15;

    var withText = rated.filter(function (r) {
      var b = (r.body || '').trim();
      return b !== '' && b !== 'No review provided.';
    });
    var own = withText.slice(0, maxD).map(card);
    if (!own.length) return;

    var sum = rated.reduce(function (s, r) { return s + r.rating; }, 0);
    var avg = Math.round((sum / rated.length) * 10) / 10;
    var n = rated.length;

    var fresh = root.cloneNode(false);
    fresh.classList.remove('upk-rev-empty-state', 'upk-rev--store');
    fresh.removeAttribute('data-upk-live');
    fresh.setAttribute('data-autoplay', 'true');
    if (!fresh.getAttribute('data-autoplay-speed')) fresh.setAttribute('data-autoplay-speed', '5000');
    fresh.innerHTML =
      '<div class="upk-rev-inner"><div class="upk-rev-head"><div class="upk-rev-head-left">' +
      '<p class="upk-rev-eyebrow">' + esc(root.getAttribute('data-eyebrow') || 'Real reviews, real shine') + '</p>' +
      '<h2>' + (root.getAttribute('data-heading') || 'What customers say about this piece') + '</h2>' +
      '</div><div class="upk-rev-head-right"><div class="upk-rev-summary">' +
      '<div class="upk-rev-summary-score">' + avg + '</div>' +
      '<div class="upk-rev-summary-stars">' + stars(avg) + '</div>' +
      '<div class="upk-rev-summary-count">' + n + ' review' + (n === 1 ? '' : 's') + ' of this piece</div>' +
      '</div><button type="button" class="upk-rev-write-btn upk-write-review-cta">Write a review</button></div></div>' +
      '<div class="upk-rev-viewport"><div class="upk-rev-track">' + own.join('') + '</div></div></div>';

    root.replaceWith(fresh);
    fresh.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  }

  function init() {
    document.querySelectorAll('.upk-rev[data-upk-live="true"]').forEach(function (root) {
      if (root._upkLiveStarted) return;
      root._upkLiveStarted = true;
      var shop = root.getAttribute('data-jdgm-shop');
      var token = root.getAttribute('data-jdgm-token');
      var pid = root.getAttribute('data-jdgm-product-id');
      if (!shop || !token || !pid) return;
      fetchAll(shop, token, pid).then(function (list) {
        if (list.length && root.isConnected) render(root, list);
      });
    });
  }
  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
